// PRAGMED — Sticky Header scroll detection
// Adds .header--scrolled class when user scrolls past the hero
(function () {
  const header = document.querySelector('.header-section');
  if (!header) return;

  const SCROLL_THRESHOLD = 80;

  function updateHeader() {
    if (window.scrollY > SCROLL_THRESHOLD) {
      header.classList.add('header--scrolled');
    } else {
      header.classList.remove('header--scrolled');
    }
  }

  window.addEventListener('scroll', updateHeader, { passive: true });
  updateHeader(); // run once on load
})();
